import { ReactNode } from "react";
import GoogleIcon from "../primary/Icon";

export type ServiceModel = {
  title: string;
  summary: string;
  description: string;
  slug: string;
  icon: ReactNode;
};

export const servicesList: ServiceModel[] = [
  {
    icon: <GoogleIcon name="routine" fontSize={48} color="lp_grey.600" />,
    title: "Everyday Life Matters",
    slug: "everyday-life-matters",
    summary: `Stora och viktiga frågor som demokrati, mänskliga rättigheter, jämlikhet och rättvisa har sina rötter i hur vi tänker, agerar och samspelar i vardagen.`,
    description: `Stora och viktiga frågor som demokrati, mänskliga rättigheter, jämlikhet och rättvisa har sina rötter i hur vi tänker, agerar och samspelar i vardagen. För barn och ungdomar är skolan och hemmet centrala arenor där de kan utveckla sin mänskliga potential och lära sig att omsätta dessa värden i praktiken.\n
    
  &nbsp; 
    
  För att stärka detta har vi utformat ett program med två integrerade spår som genomförs parallellt – i skolan och i hemmet. Programmet, som riktar sig till elever i årskurs 7–9, innehåller berättelser, diskussioner och praktiska övningar. Vi erbjuder inte bara material för lärare, utan även förberedande träning och löpande coaching. Genom detta program skapar vi en ny modell för samarbete mellan skolan och hemmet, där båda parter aktivt bidrar till elevernas utveckling.
`,
  },
  {
    icon: (
      <GoogleIcon
        name="settings_accessibility"
        fontSize={48}
        color="lp_grey.600"
      />
    ),
    title: "UNGDOMSLEDARUTBILDNING",
    slug: "youth-leadership-education",
    summary: `Ledarskap är förmågan att se den bästa potentialen i andra människor och i situationer, och att kunna hjälpa till att realisera denna potential.`,
    description: `Ledarskap är förmågan att se den bästa potentialen i andra människor och i situationer, och att kunna hjälpa till att realisera denna potential. Många unga människor har redan utvecklat attityder och färdigheter inom sådant ledarskap. Genom att bjuda in dem och erbjuda olika möjligheter att utveckla och utöva sitt ledarskap kan skolor bättre lyckas med att förverkliga varje elevs potential och frigöra de kollektiva konstruktiva krafter som finns i elevgruppen. Denna kurs kommer att vägleda de deltagande eleverna att lära känna sig själva bättre, att uppnå självbehärskning och inre ledarskap i sina egna liv, och att hjälpa andra att bli medvetna om och styra sina förmågor mot att tjäna det gemensamma bästa. Justerade versioner av kursen finns för åldrarna 10-18.`,
  },
  {
    icon: <GoogleIcon name="trophy" fontSize={48} color="lp_grey.600" />,
    title: "GLOBALA HJÄLTAR TILLSAMMANS",
    slug: "global-heroes-all-together",
    summary: `Hjältedåd anses vanligtvis vara något som är förknippat med några få exceptionella individer. Dagens världssituation kräver många ...`,
    description: `Hjältedåd anses vanligtvis vara något som är förknippat med några få exceptionella individer. Dagens världssituation kräver många grundläggande omvandlingar och ropar efter en hel generation hjältar. Alla unga människor har potentialen att leva upp till detta historiska uppdrag, i samarbete med varandra. Detta är en ettårig integrerad gymnasiekurs som kommer med färdiga lektionsplaner och material. Den första terminen består av konceptuella studier, medan den andra terminen är tillägnad att genomföra och lära sig från lokala serviceprojekt. Vi erbjuder ett kurspaket för eleverna samt förberedande träning och fortlöpande coaching för lärare.`,
  }
];
